import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber'
})
export class NumberPipe implements PipeTransform {

  transform(value: any, locale?: string): any {
    if (value) {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0
      }).format(Number(value));
    } else {
      return 0;
    }
  }
}

@Pipe({
  name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {
  transform(value: string):any {
      let retNumber = Number(value);
      return isNaN(retNumber) ? 0 : retNumber.toFixed(2);
  }
}
